<div id="contact_hm" class="p-3">
  <h1 class="text-gradient-drfeel">
    Ciao {{ nomeUtente }}, sono Donatella la tua Health Manager
  </h1>
  <p class="fw-bold">Come posso aiutarti?</p>
  <div class="detail_hm">
    <div class="d-inline-flex align-items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21.08"
        height="20.999"
        viewBox="0 0 21.08 20.999"
      >
        <g
          id="Raggruppa_21553"
          data-name="Raggruppa 21553"
          transform="translate(-0.017 0.061)"
        >
          <g
            id="Raggruppa_21611"
            data-name="Raggruppa 21611"
            transform="translate(-5 -3)"
          >
            <path
              id="Tracciato_85501"
              data-name="Tracciato 85501"
              d="M.542,20.5a.542.542,0,0,1-.379-.93L3.1,17.189A10.5,10.5,0,0,1,.036,10.25C-.472,4.62,4.633,0,10.284,0a10.248,10.248,0,0,1,0,20.5H.542m9.735-19.36A9.11,9.11,0,0,0,3.839,16.694l.022.022a.546.546,0,0,1-.015.772L1.635,19.352l1.562.007h7.087A9.11,9.11,0,0,0,16.715,3.8a9.051,9.051,0,0,0-6.438-2.665m.007,12.905a.569.569,0,1,1,.569-.569.57.57,0,0,1-.569.569m0-3.226a.57.57,0,0,1-.569-.569V7.022a.569.569,0,1,1,1.139,0v3.226a.57.57,0,0,1-.569.569"
              transform="translate(5.315 3.189)"
              fill="#2f2f2f"
              stroke="#2f2f2f"
              stroke-width="0.5"
            />
          </g>
        </g>
      </svg>
      <p class="m-0">Vuoi informazioni<br />sul servizio?</p>
    </div>
    <div class="d-inline-flex align-items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="21"
        height="27"
        viewBox="0 0 21 27"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rettangolo_9490"
              data-name="Rettangolo 9490"
              width="21"
              height="27"
              transform="translate(0.376 -0.013)"
              fill="#2f2f2f"
              stroke="#2f2f2f"
              stroke-width="0.5"
            />
          </clipPath>
        </defs>
        <g
          id="Raggruppa_21547"
          data-name="Raggruppa 21547"
          transform="translate(-0.376 0.494)"
        >
          <g
            id="Raggruppa_21548"
            data-name="Raggruppa 21548"
            transform="translate(0 -0.481)"
          >
            <g
              id="Raggruppa_21547-2"
              data-name="Raggruppa 21547"
              clip-path="url(#clip-path)"
            >
              <path
                id="Tracciato_85496"
                data-name="Tracciato 85496"
                d="M27.9,24.306l-3.5-1.471a.975.975,0,0,1-.6-.9V20.057l.045-.027h3.73a1.99,1.99,0,0,0,1.987-1.988v-6.4a8.4,8.4,0,0,0-2.314-5.818L28.53,4.115q.231-.508-.314-.628H26.8l.555-2.433a.4.4,0,0,0-.7-.323l-2.313,3.09a8.523,8.523,0,0,0-7.114.275L15.7,1.445a.393.393,0,0,0-.68.393l1.53,2.649q-.263.167-.516.355a.393.393,0,1,0,.468.63q.216-.161.441-.3l.539.933a.4.4,0,0,0,.536.143.393.393,0,0,0,.143-.536l-.537-.93a7.738,7.738,0,0,1,6.234-.305l-.346.462q-.231.508.314.628h1.413l-.555,2.433a.394.394,0,0,0,.7.323l1.387-1.852a7.622,7.622,0,0,1,2.007,5.18v6.4a1.2,1.2,0,0,1-1.2,1.2H25.144a2.878,2.878,0,0,0,1.59-2.519v-.909a.393.393,0,1,0-.785,0v.909a1.991,1.991,0,0,1-.957,1.694L22.16,20.131a2.58,2.58,0,0,1-2.674,0L16.653,18.42a1.99,1.99,0,0,1-.957-1.694V14.659c3.608-1.263,1.4-4.23,3.7-4.941a5.326,5.326,0,0,0,3.1-2.229,5.3,5.3,0,0,0,3.447,3.493v2.752a.393.393,0,0,0,.785,0V10.663a.4.4,0,0,0-.351-.39,4.484,4.484,0,0,1-3.226-3.329.649.649,0,0,0-1.209-.095,4.175,4.175,0,0,1-2.785,2.119,2.558,2.558,0,0,0-1.815,2.467A2.629,2.629,0,0,1,15.191,14a.392.392,0,0,0-.28.376v2.353a2.878,2.878,0,0,0,1.59,2.519H14.6a1.2,1.2,0,0,1-1.2-1.2v-6.4a7.613,7.613,0,0,1,1.593-4.686.393.393,0,0,0-.622-.479,8.394,8.394,0,0,0-1.756,5.166v6.4A1.99,1.99,0,0,0,14.6,20.03h3.2l.168.1v1.783a.974.974,0,0,1-.6.9l-3.551,1.492a5.193,5.193,0,0,0-2.788,2.456c-.227.426.437.849.693.368a4.651,4.651,0,0,1,2.39-2.1l3.56-1.5a1.758,1.758,0,0,0,1.08-1.624V20.606a3.546,3.546,0,0,0,4.262-.074v1.4a1.758,1.758,0,0,0,1.079,1.623l3.5,1.475A4.58,4.58,0,0,1,30,27.12c.253.484.919.064.7-.363a5.152,5.152,0,0,0-2.8-2.451M26.041,4.924a.393.393,0,0,0-.307-.148H24.614l1.567-2.094c-.28,1.392-.152,1.552.129,1.589h1.121L25.864,6.366l.253-1.11a.393.393,0,0,0-.076-.332"
                transform="translate(-10.217 -0.119)"
                fill="#2f2f2f"
                stroke="#2f2f2f"
                stroke-width="0.5"
              />
              <path
                id="Tracciato_85502"
                data-name="Tracciato 85502"
                d="M14.958,4.512l.607-1.086,1.561,1.086-.747.363-.813-.363Z"
                fill="none"
                stroke="#2f2f2f"
                stroke-width="1"
              />
            </g>
          </g>
          <g
            id="Raggruppa_21550"
            data-name="Raggruppa 21550"
            transform="translate(0 -0.481)"
          >
            <g
              id="Raggruppa_21549"
              data-name="Raggruppa 21549"
              clip-path="url(#clip-path)"
            >
              <path
                id="Tracciato_85497"
                data-name="Tracciato 85497"
                d="M122.705,235.843a1.379,1.379,0,0,0-1.359,0,.566.566,0,0,1-.6,0,1.38,1.38,0,0,0-1.36,0,.5.5,0,0,1-.3.087.392.392,0,0,0-.392.393c.038.612.839.363,1.073.209a.566.566,0,0,1,.6,0,1.38,1.38,0,0,0,1.36,0,.565.565,0,0,1,.6,0c.234.155,1.033.4,1.072-.209a.392.392,0,0,0-.393-.392.5.5,0,0,1-.3-.087"
                transform="translate(-110.405 -218.794)"
                fill="#2f2f2f"
                stroke="#2f2f2f"
                stroke-width="0.5"
              />
            </g>
          </g>
          <g
            id="Raggruppa_21552"
            data-name="Raggruppa 21552"
            transform="translate(0 -0.481)"
          >
            <g
              id="Raggruppa_21551"
              data-name="Raggruppa 21551"
              clip-path="url(#clip-path)"
            >
              <path
                id="Tracciato_85498"
                data-name="Tracciato 85498"
                d="M150.5,2.114a.393.393,0,0,0,.393-.393V.393a.393.393,0,1,0-.785,0V1.721a.393.393,0,0,0,.392.393"
                transform="translate(-139.626 0.418)"
                fill="#2f2f2f"
                stroke="#2f2f2f"
                stroke-width="0.5"
              />
              <path
                id="Tracciato_85499"
                data-name="Tracciato 85499"
                d="M3.157,67.852a.4.4,0,0,0,.2-.733L.971,65.744a.393.393,0,0,0-.392.68L2.961,67.8a.391.391,0,0,0,.2.053"
                transform="translate(-0.355 -60.686)"
                fill="#2f2f2f"
                stroke="#2f2f2f"
                stroke-width="0.5"
              />
              <path
                id="Tracciato_85500"
                data-name="Tracciato 85500"
                d="M268.584,65.909a.392.392,0,0,0-.536-.144l-2.44,1.408a.393.393,0,0,0-.144.536.4.4,0,0,0,.536.144l2.44-1.408a.393.393,0,0,0,.144-.536"
                transform="translate(-246.883 -60.707)"
                fill="#2f2f2f"
                stroke="#2f2f2f"
                stroke-width="0.5"
              />
            </g>
          </g>
        </g>
      </svg>
      <p class="m-0">Hai un sintomo e<br />non sai cosa fare?</p>
    </div>
    <div class="d-inline-flex align-items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30.376"
        height="30.639"
        viewBox="0 0 30.376 30.639"
      >
        <g
          id="Raggruppa_21487"
          data-name="Raggruppa 21487"
          transform="translate(-697.482 -483.168)"
        >
          <path
            id="Tracciato_85327"
            data-name="Tracciato 85327"
            d="M3.286,21.56a14.98,14.98,0,0,0,3.49,1.254.524.524,0,1,0,.23-1.022,13.966,13.966,0,0,1-2.959-1.025V18c0-1.778,1.693-3.377,4.139-3.941.76.437,1.238-.647.382-.992a4.386,4.386,0,0,1-1.533-2.3.523.523,0,0,0-.5-.369H6.226a.658.658,0,0,1-.655-.66,4.48,4.48,0,0,1,.031-.77.522.522,0,0,0,.866-.186c.079-.224.159-.427.235-.6.252-.642.838-1.518,1.215-1.511.784-.012,1.143.384,2.111.361.964.028,1.328-.376,2.109-.361.416.052.8.6,1.053,1.05a.524.524,0,0,0,.717.2.527.527,0,0,0,.783-.455V6.181A3.286,3.286,0,0,0,11.578,2.75H8.563A3.286,3.286,0,0,0,5.451,6.181V7.634a1.7,1.7,0,0,0-.927,1.511v.592A1.708,1.708,0,0,0,6.16,11.444a5.868,5.868,0,0,0,1.049,1.8C4.689,14.069,3,15.928,3,18v3.09a.524.524,0,0,0,.287.467ZM6.5,6.181A2.243,2.243,0,0,1,8.562,3.8h3.017A2.337,2.337,0,0,1,13.643,6.5a1.987,1.987,0,0,0-1.857-.883,11.486,11.486,0,0,1-1.755.359,10.09,10.09,0,0,1-1.726-.356A1.887,1.887,0,0,0,6.5,6.441Z"
            transform="translate(694.482 480.418)"
            fill="#2f2f2f"
          />
          <path
            id="Tracciato_85328"
            data-name="Tracciato 85328"
            d="M12,29v3.09a.524.524,0,0,0,.286.467A15.558,15.558,0,0,0,21.337,34a.524.524,0,1,0-.156-1.036,14.42,14.42,0,0,1-8.134-1.2V29c0-1.78,1.7-3.38,4.146-3.942a3.747,3.747,0,0,0,3.752,0,4.065,4.065,0,0,0,.477.1.522.522,0,0,0,.427-.815,5.622,5.622,0,0,0,1.136-1.9,1.708,1.708,0,0,0,1.633-1.706v-.592a1.709,1.709,0,0,0-.93-1.516V17.182a3.287,3.287,0,0,0-3.109-3.432H17.562a3.287,3.287,0,0,0-3.109,3.432v1.451a1.7,1.7,0,0,0-.929,1.512v.592a1.708,1.708,0,0,0,1.636,1.706,5.873,5.873,0,0,0,1.051,1.8C13.69,25.068,12,26.928,12,29Zm3.5-11.82A2.243,2.243,0,0,1,17.562,14.8h3.016A2.336,2.336,0,0,1,22.64,17.5a1.963,1.963,0,0,0-1.82-.88,12.975,12.975,0,0,1-1.789.356,13.087,13.087,0,0,1-1.8-.359,1.881,1.881,0,0,0-1.734.823Zm.035,4.215h-.309a.658.658,0,0,1-.655-.66,4.261,4.261,0,0,1,.031-.772.522.522,0,0,0,.867-.183c.567-1.425.936-2.173,1.714-2.114a7.366,7.366,0,0,0,1.848.359c.965.028,1.33-.37,2.108-.359.289.035.863.361,1.535,2.125a.522.522,0,0,0,.864.173,4.228,4.228,0,0,1,.031.772.658.658,0,0,1-.655.66h-.309a.524.524,0,0,0-.5.373c-.222.994-1.389,2.868-3.034,2.748-1.587.126-2.788-1.681-3.035-2.752A.524.524,0,0,0,15.534,21.4Z"
            transform="translate(690.197 475.18)"
            fill="#2f2f2f"
          />
          <path
            id="Tracciato_85329"
            data-name="Tracciato 85329"
            d="M18.094,27.434a.524.524,0,0,0,.524-.524V25.863h1.048a.524.524,0,1,0,0-1.048H18.618V23.768a.524.524,0,1,0-1.048,0v1.048H16.523a.524.524,0,1,0,0,1.048H17.57v1.048A.524.524,0,0,0,18.094,27.434ZM22.867,9.647a.523.523,0,0,0,.6-.442A2.159,2.159,0,0,1,25.49,7.238H28.5a2.34,2.34,0,0,1,2.064,2.708,1.974,1.974,0,0,0-1.874-.877,10.211,10.211,0,0,1-1.741.353c-1,.006-1.72-.656-2.67-.227a.524.524,0,0,0,.447.947,1.359,1.359,0,0,1,.863.091,4.311,4.311,0,0,0,2.719,0c.926-.343,1.3-.016,1.908,1.127a8.688,8.688,0,0,1,.38.876.522.522,0,0,0,.867.172,4.284,4.284,0,0,1,.031.775.66.66,0,0,1-.66.659h-.3a.524.524,0,0,0-.5.369,4.359,4.359,0,0,1-1.536,2.3c-.447.442-1.557.234-1.467,1.013a.525.525,0,0,0,.6.433c1.582-.152,2.922-1.891,3.277-3.069a1.709,1.709,0,0,0,1.636-1.706v-.592a1.688,1.688,0,0,0-.932-1.516V9.626A3.29,3.29,0,0,0,28.5,6.19H25.49a3.2,3.2,0,0,0-3.064,2.861.524.524,0,0,0,.441.6Zm.2,15.954a7.618,7.618,0,0,0,11.41,6.557l2.409,2.409a1.568,1.568,0,1,0,2.218-2.218l-2.3-2.3A7.59,7.59,0,1,0,23.071,25.6Zm15.3,7.491c.487.482-.259,1.209-.739.734l-2.268-2.268a7.65,7.65,0,0,0,.772-.7ZM37.212,25.6a6.547,6.547,0,1,1-6.547-6.547A6.555,6.555,0,0,1,37.212,25.6Z"
            transform="translate(688.292 478.78)"
            fill="#2f2f2f"
          />
          <path
            id="Tracciato_85330"
            data-name="Tracciato 85330"
            d="M33.5,38.25a5.5,5.5,0,1,0,5.5-5.5A5.506,5.506,0,0,0,33.5,38.25Zm9.952,0A4.452,4.452,0,1,1,39,33.8,4.457,4.457,0,0,1,43.451,38.25Z"
            transform="translate(679.958 466.132)"
            fill="#2f2f2f"
          />
        </g>
      </svg>
      <p class="m-0">Vuoi trovare<br />uno specialista?</p>
    </div>
    <div class="d-inline-flex align-items-center">
      <svg
        id="Raggruppa_21316"
        data-name="Raggruppa 21316"
        xmlns="http://www.w3.org/2000/svg"
        width="18.044"
        height="27"
        viewBox="0 0 18.044 27"
      >
        <path
          id="Tracciato_85431"
          data-name="Tracciato 85431"
          d="M129.778,7.1a3.73,3.73,0,0,1-3.423-2.734h1.254a1.373,1.373,0,0,0,1.476-1.234v-1.9A1.373,1.373,0,0,0,127.609,0H116.317a1.373,1.373,0,0,0-1.476,1.234v1.9a1.373,1.373,0,0,0,1.476,1.234h1.254A3.73,3.73,0,0,1,114.148,7.1a1.286,1.286,0,0,0-1.207,1.195V25.807A1.327,1.327,0,0,0,114.368,27h15.19a1.327,1.327,0,0,0,1.427-1.193V8.294A1.286,1.286,0,0,0,129.778,7.1Zm-.22,19.11h-15.19a.447.447,0,0,1-.481-.4V23.823h11.051a.4.4,0,1,0,0-.791H113.887V11.116l3.625,0a.4.4,0,1,0,0-.791l-3.625,0V8.294a.446.446,0,0,1,.411-.414c2.294-.308,4-1.755,4.227-3.515h3.048a.44.44,0,0,0,.473-.4.44.44,0,0,0-.473-.4h-5.256a.493.493,0,0,1-.53-.443V2.116h1.9a.44.44,0,0,0,.473-.4.44.44,0,0,0-.473-.4h-1.9V1.234a.493.493,0,0,1,.53-.443h11.292a.493.493,0,0,1,.53.443v1.02h-1.906a.44.44,0,0,0-.473.4.44.44,0,0,0,.473.4h1.906v.086a.493.493,0,0,1-.53.443h-3.82a.44.44,0,0,0-.473.4.44.44,0,0,0,.473.4H125.4c.225,1.761,1.932,3.208,4.226,3.515a.446.446,0,0,1,.411.414v2.031H119.712a.4.4,0,1,0,0,.791h10.327V23.032h-2.889a.4.4,0,1,0,0,.791h2.89v1.984A.447.447,0,0,1,129.558,26.209Z"
          transform="translate(-112.941)"
          fill="#2f2f2f"
        />
        <path
          id="Tracciato_85432"
          data-name="Tracciato 85432"
          d="M146.41,231.423a1.454,1.454,0,0,0,.6-1.113v-2.386a1.928,1.928,0,0,0-2-1.583,1.862,1.862,0,0,0-1.948,1.587v2.386C143.072,231.586,145.08,232.493,146.41,231.423Zm-2.056-4.05a1.037,1.037,0,0,1,1.67.554v.8h-1.982v-.8A.743.743,0,0,1,144.354,227.373Zm-.312,2.937v-.8h1.982v.8a.743.743,0,0,1-.312.55A1.031,1.031,0,0,1,144.042,230.31Zm6.438,1.244a2.409,2.409,0,0,0-2.8,0l-2.1,1.687c-1.108.906-.494,2.688,1.392,2.688a2.255,2.255,0,0,0,1.406-.447l2.1-1.687A1.444,1.444,0,0,0,150.481,231.554Zm-2.8,3.37a1.217,1.217,0,0,1-.706.212c-1.025,0-1.171-.948-.692-1.34l.7-.563,1.4,1.125Zm2.1-1.687-.7.563-1.4-1.125.7-.565a1.149,1.149,0,0,1,.705-.212C150.124,231.9,150.235,232.865,149.781,233.237Zm7.342-3.5c1.476-1.588,1.034-3.127-.1-3.8a3.023,3.023,0,0,0-3.246.175c-2.448-1.772-6,.778-3.347,3.628a10.889,10.889,0,0,0,3.123,1.888.6.6,0,0,0,.449,0A10.889,10.889,0,0,0,157.123,229.741Zm-3.347,1.088a9.169,9.169,0,0,1-2.558-1.561,2.028,2.028,0,0,1-.663-2.008,1.709,1.709,0,0,1,2.8-.344.563.563,0,0,0,.832,0,1.84,1.84,0,0,1,1.137-.565c1.392-.176,2.568,1.234,1,2.917A9.165,9.165,0,0,1,153.776,230.828Z"
          transform="translate(-141.469 -213.633)"
          fill="#2f2f2f"
        />
      </svg>
      <p class="m-0">Hai bisogno di<br />una prescrizione?</p>
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <div class="btn_hm">
      <button class="do3-secondary-btn me-sm-3 mb-3 mb-sm-0 wa">
        <a
          href="https://wa.me/393757347706"
          target="_blank"
          class="text-decoration-none text-uppercase"
        >
          <img src="./assets/images/profilo_icons/WhatsApp.svg" />

          Contattami via chat
        </a>
      </button>

      <a
        href="prenotazione?step=calendario&docId=39x2619&specId=38x59"
        target="_blank"
        class="book_hm"
      >
        <svg
          id="Raggruppa_21595"
          data-name="Raggruppa 21595"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="23.084"
          height="18"
          viewBox="0 0 23.084 18"
          class="me-2"
        >
          <defs>
            <clipPath id="clip-path">
              <rect
                id="Rettangolo_9536"
                data-name="Rettangolo 9536"
                width="23.084"
                height="18"
                fill="#ff0058"
              />
            </clipPath>
          </defs>
          <g id="Raggruppa_21595-2" data-name="Raggruppa 21595">
            <path
              id="Tracciato_85505"
              data-name="Tracciato 85505"
              d="M459.886,138.7v.49a.337.337,0,0,1,0-.49"
              transform="translate(-439.047 -132.446)"
              fill="#ff0058"
            />
            <path
              id="Tracciato_85506"
              data-name="Tracciato 85506"
              d="M187.527,227.083c.021-.008-.006,0,0,0"
              transform="translate(-179.07 -216.84)"
              fill="#ff0058"
            />
            <path
              id="Tracciato_85507"
              data-name="Tracciato 85507"
              d="M22.309,14.768h-.477a1.545,1.545,0,0,0,.27-.875v-5.5h.019l.06-5.462H22.1V1.555A1.555,1.555,0,0,0,20.548,0H18.889a.346.346,0,0,0-.348.3.338.338,0,0,0,.335.381h1.672a.879.879,0,0,1,.878.878V2.933h-.011V8.394h.01v5.5a.879.879,0,0,1-.81.875H2.422a.879.879,0,0,1-.811-.875V1.555A.879.879,0,0,1,2.49.676H17.285a.347.347,0,0,0,.349-.3A.338.338,0,0,0,17.3,0H2.49A1.555,1.555,0,0,0,.936,1.555V13.893a1.545,1.545,0,0,0,.27.875H.776A.777.777,0,0,0,0,15.546,2.452,2.452,0,0,0,2.445,18H3.783a.347.347,0,0,0,.349-.3.338.338,0,0,0-.336-.381H2.445A1.775,1.775,0,0,1,.676,15.546a.1.1,0,0,1,.1-.1l6.147,0v.377a.9.9,0,0,0,.895.9h5.175a.346.346,0,0,0,.349-.3.338.338,0,0,0-.335-.381H7.818a.222.222,0,0,1-.218-.221v-.377h7.885v.377a.222.222,0,0,1-.218.221H14.6a.347.347,0,0,0-.349.3.338.338,0,0,0,.335.38h.683a.9.9,0,0,0,.895-.9v-.377c4.774,0,1.58,0,6.147,0a.1.1,0,0,1,.1.1,1.775,1.775,0,0,1-1.769,1.778H5.387a.347.347,0,0,0-.349.3A.338.338,0,0,0,5.374,18H20.639a2.452,2.452,0,0,0,2.445-2.454.777.777,0,0,0-.776-.777m-2.13-13.5H2.859a.66.66,0,0,0-.66.66v11.6a.66.66,0,0,0,.66.66H20.178a.66.66,0,0,0,.66-.66V1.924a.66.66,0,0,0-.66-.66M10.355,13.506h-.8v-.741a.346.346,0,0,0-.3-.348.338.338,0,0,0-.38.335v.753H7.914a13.868,13.868,0,0,1,.441-2.368.662.662,0,0,1,.35-.264c.171-.055.913-.317,1.08-.377l.229.7a.56.56,0,0,0,.616.381l.145.356Zm.253-2.666-.2-.625.12-.074.453.441-.369.257M9.037,7.447a.4.4,0,0,1-.387-.358.4.4,0,0,1,.386-.358c0,.057,0,.093,0,.717M8.909,6.065A3.075,3.075,0,0,1,9,5.132a2.6,2.6,0,0,1,5.1.558,2.375,2.375,0,0,1,0,.376,1.209,1.209,0,0,0-.128-.012V5.777a.442.442,0,0,0-.4-.441c-.45-.044-.353-.483-.792-.552a.513.513,0,0,0-.412.119,2.671,2.671,0,0,1-2.164.574,1.024,1.024,0,0,0-1.074.577,1.176,1.176,0,0,0-.225.013m5.3,1.3a.488.488,0,0,1-.234.086V6.73c.365.036.531.421.234.631m-4.5-.873a.347.347,0,0,1,.4-.343,3.351,3.351,0,0,0,2.559-.614,1.177,1.177,0,0,0,.632.439c0,1.562,0,1.334,0,1.406a1.8,1.8,0,0,1-3.58.052c-.009-.11-.006-.62-.006-.94m1.342,7.019.335-1.254h.233l.335,1.254Zm.166-2.269.286-.2.286.2-.138.338h-.3Zm.294-1.075-.463-.451a2.662,2.662,0,0,0,.98-.019Zm1.033-.025.1.064-.24.643-.134-.093-.229-.159Zm1.585,3.369v-.741a.346.346,0,0,0-.3-.348.338.338,0,0,0-.38.335v.753h-.8l-.419-1.571.145-.357A.56.56,0,0,0,13,11.207l.268-.718c.055.018-.08-.029,1,.351.669.237.49.25.916,2.667Zm6.029,0h-4.3c-.3-1.818-.268-1.673-.335-2.045a1.42,1.42,0,0,0-.85-1.2s.106.031-1.414-.494h0c-.112-.039,0,.006-.416-.244V9.368a2.3,2.3,0,0,0,1-1.246,1.038,1.038,0,0,0,.938-1.7,7.817,7.817,0,0,0-.006-.795,3.181,3.181,0,0,0-2.911-3.05A3.184,3.184,0,0,0,8.352,4.952a4.866,4.866,0,0,0-.119,1.472,1.04,1.04,0,0,0,.951,1.7,2.344,2.344,0,0,0,1.051,1.3v.106l-.378.232h0c-1.1.384-1.344.468-1.389.482H8.457a1.347,1.347,0,0,0-.669.528c-.174.27-.1.161-.561,2.736H2.876V1.94H20.162Z"
              fill="#ff0058"
            />
          </g>
        </svg>
        Prenota un videoconsulto
      </a>
    </div>
  </div>
</div>
